module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-svg-sprite-footer-822d3d590ec9d17d367c29395162d880.svg";